<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="紧急程度" required>
				<c-radio-group name="urgency_level" :options="orderUrgencyDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="关联售后工单" required>
				<c-select v-model="workOrderId" ref="orderSelect" name="aftersale_order_id" async :disabled="!!source" :clear="false" @search="searchOrder">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								`${data.data.customer_name||'-'} | ${data.data.create_date}`
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="AFTERSALE_ORDER" :id="workOrderId"></info-card>
			</c-form-item>
			<c-form-item label="计划使用时间" required>
				<c-datetime type="datetime" name="plan_use_time" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</c-form-item>
			<c-form-item label="预计归还时间" required>
				<c-datetime type="datetime" name="plan_return_time" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</c-form-item>
			<c-form-item label="领用资产明细" name="item_list" required>
				<detail-card v-for="(item, i) in assetsList" :key="i" :index="i + 1">
					<template #title>
						<p>{{item.asset_name}}</p>
					</template>
					<c-field label="资产分类">{{item.asset_category || '-'}}</c-field>
                    <c-field label="资产编号">{{item.asset_code || '-'}}</c-field>
					<template #form>
						<detail-card-form label="领用数量" required>
							<c-input value="1" type="number" name="receive_quantity" :range="[1, Infinity]" disabled :append-text="item.unit_name"></c-input>
						</detail-card-form>
						<detail-card-form label="上传附件" required>
							<c-upload-file v-model="item.voucher_image_url" name="voucher_image_url" media multiple="9" type="image,video" :side="false" @click="takePhoto"></c-upload-file>
						</detail-card-form>
					</template>
					<template #button>
						<c-link color="red" icon="tf-trash" @click="assetsList.splice(i, 1)">删除</c-link>
					</template>
				</detail-card>
				<c-button size="form" color="main" hollow prepend-icon="c-icon-add" style="width: 100%; margin-top: .2rem;" @click="addAssetsHandle">选择资产</c-button>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="form" @click="submitHandle(-1)">暂存</c-button>
			<c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String,
			source: String
		},

		data() {
			return {
				workOrderId: '',
				assetsList: []
			}
		},

		computed: {
			...mapState(['orderUrgencyDic'])
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/asset_receive_apply/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.$refs.form.set(data);
						this.$refs.orderSelect.setValueData([{
							name: data.aftersale_order_code,
							value: data.aftersale_order_id
						}]);
						this.assetsList = data.item_list;
					}
				})
			} else if (this.source) {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.source
					},
					success: ({detailInfo}) => {
						this.$refs.form.set({
							urgency_level: 1,
							plan_use_time: new Date().format('yyyy-MM-dd hh:mm')
						});
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.id
						}]);
					}
				});
			} else {
				this.$refs.form.set({
					urgency_level: 1,
					plan_use_time: new Date().format('yyyy-MM-dd hh:mm')
				});
			}
		},

		methods: {
			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_ORDER',
						is_charge: 1,
						status: [2, 3, 4],
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.order_number,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			addAssetsHandle() {
				this.globalDialog('assetsSelector', {
					props: {
						multiple: true,
						status: 1  // 仅查询【空闲】资产
					}
				}, data => {
					data.forEach(item => {
						item.asset_id = item.id;
					});
					this.assetsList = this.assetsList.concat(data.filter(item => !this.assetsList.find(temp => temp.id == item.id)));
				});
			},

			submitHandle(state) {
				this.$refs.form.submit({
					url: this.id ? '/asset_receive_apply/edit' : '/asset_receive_apply/add',
					rule: {
						urgency_level: '请选择紧急程度',
						aftersale_order_id: '请选择关联工单',
						plan_use_time: '请选择计划使用时间',
						plan_return_time: '请选择预计归还时间',
						item_list: () => {
							if (!this.assetsList.length || this.assetsList.find(item => !item.voucher_image_url.length)) {
								return '请完善领用资产明细';
							}
							return true;
						}
					},
					dataFormatter: data => {
						data.id = this.id;
						data.apply_status = state;
						data.item_list = this.assetsList.map(item => {
							return {
								asset_id: item.asset_id,
								receive_quantity: 1,
								voucher_image_url: item.voucher_image_url.join(',')
							}
						});
						return data;
					},
					success: (data, res) => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						setTimeout(() => {
							if (this.id) {
								this.mp.navigateBack();
							} else {
								this.mp.redirectWeb('/assets/receive/detail', {id: res.apply_id});
							}
						}, 1000);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>